module.exports = __webpack_public_path__ + "static/media/21.83e9b513.mp3";